module.exports = __webpack_public_path__ + "static/media/maker_dao.c5bbb195.svg";